import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { JobPhaseBumpPhotoCreatableInterface } from '../interfaces/job-phase-bump-photo-creatable.interface';
import { JobPhaseBumpPhotoDto } from './job-phase-bump-photo.dto';

export class JobPhaseBumpPhotoCreateDto
  extends IntersectionType(
    PickType(JobPhaseBumpPhotoDto, ['fileName', 'jobPhaseBumpId']),
    PartialType(PickType(JobPhaseBumpPhotoDto, ['metaData'])),
  )
  implements JobPhaseBumpPhotoCreatableInterface {}
